import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import './styles.css';

const AIMeetingPro = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // 監聽滾動事件改變header樣式
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // 處理從其他頁面導航到特定section的邏輯
    if (location.state && location.state.scrollTo) {
      const sectionId = location.state.scrollTo;
      const element = document.getElementById(sectionId);
      if (element) {
        // 等待頁面渲染完成後滾動
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  // 點擊導航項後滾動到對應section
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 70, // 減去header高度的偏移
        behavior: 'smooth'
      });
      setMobileMenuOpen(false); // 點擊後關閉移動端菜單
    }
  };

  return (
    <div className="aimeetingpro-container">
      {/* Header Navigation */}
      <Header />
      {/* Hero Section */}
      <section id="hero" className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1>The Smartest Way to Prepare for Interviews</h1>
            <p>Seamlessly practice, analyze, and improve your interview skills with AI to boost your success rate.</p>
            <div className="cta-group">
              <button className="cta-button primary">Try for Free</button>
              <button className="cta-button secondary">See Pricing</button>
            </div>
          </div>
          
          <div className="hero-demo">
            <div className="video-wrapper">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
                  title="AI Interview Assistant Demo"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <h2>Your Partner for Smarter Interview Preparation</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Perfect for Any Interview Type</h3>
            <p>Practice technical interviews, behavioral questions, or case studies with our AI-powered system.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📝</div>
            <h3>How it works ?</h3>
            <p>Upload your resume and record interview questions. Our AI will analyze your background and recommend the best responses tailored to your experience.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🤖</div>
            <h3>Powered by Advanced AI</h3>
            <p>Our AI understands context, evaluates responses, and provides personalized improvement suggestions.</p>
          </div>
          {/* <div className="feature-card">
            <div className="feature-icon">🌐</div>
            <h3>Extensive Industry Coverage</h3>
            <p>Practice interviews for various industries including tech, finance, consulting, and more.</p>
          </div> */}
        </div>
      </section>

      {/* Testimonials Section */}
      {/* 
      <section id="testimonials" className="testimonials-section">
        <h2>Trusted by Professionals Everywhere</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p className="quote">"The AI feedback is incredibly detailed and helpful. It's like having a personal interview coach available 24/7."</p>
            <div className="author">
              <h4>Sarah Chen</h4>
              <p>Software Engineer, Google</p>
            </div>
          </div>
          <div className="testimonial-card">
            <p className="quote">"The practice sessions helped me identify and improve my weak points. I landed my dream job at Microsoft!"</p>
            <div className="author">
              <h4>Michael Rodriguez</h4>
              <p>Product Manager, Microsoft</p>
            </div>
          </div>
          <div className="testimonial-card">
            <p className="quote">"The most comprehensive interview preparation tool I've used. The AI's ability to simulate real interview scenarios is impressive."</p>
            <div className="author">
              <h4>Emily Thompson</h4>
              <p>Data Scientist, Amazon</p>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* FAQ Section */}
      <section id="faq" className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3>What is AI Meeting Pro?</h3>
            <p>AI Meeting Pro is an AI-powered interview preparation tool that provides intelligent answer recommendations and coaching to help you overcome nervousness and confidently respond during interviews.</p>
          </div>
          <div className="faq-item">
            <h3>Can I try it for free?</h3>
            <p>Yes! We offer a 7-day free trial with up to 50 voice recognition sessions and AI-powered answer recommendations. You can upgrade to our premium plans for unlimited access and advanced features.</p>
          </div>
          <div className="faq-item">
            <h3>What types of interviews can I use AI Meeting Pro?</h3>
            <p>We support various interview types including technical interviews, behavioral questions, case studies, and industry-specific scenarios. You only need to upload your resume details.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="pricing" className="cta-section">
        <div className="cta-limited-offer">Limited Time Offer</div>
        <h2>Transform Your Interview Success Rate Today</h2>
        <p>Join over 10,000+ professionals who landed their dream jobs using AI Interview Assistant</p>
        <div className="price-container">
          <div className="original-price">$999.99/month</div>
          <div className="current-price">$99<span>/month</span></div>
          <div className="discount-tag">90% OFF</div>
        </div>
        <div className="guarantee">30-Day Money Back Guarantee</div>
        <div className="cta-group">
          <button className="cta-button primary">Get Started Now</button>
          <button className="cta-button secondary">View All Plans</button>
        </div>
        <div className="spots-left">Only <span>37 spots</span> left at this price!</div>
      </section>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AIMeetingPro; 